import { FoundationElement } from '@microsoft/fast-foundation';
import { ChameleonElementMixin } from '../common/mixin';
export class ContextualActionSeparatorComponent extends ChameleonElementMixin(FoundationElement) {
}
